import { ReportBreadcrumb } from 'components/Breadcrumb'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { ProductBalancing } from 'components/ProductBalancing'
import { ReportHeader } from 'components/ReportHeader'  
import {
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    TabsContext
} from 'monday-ui-react-core'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { LoaderContext } from 'utils/context/LoaderContext'
import { StatementContext } from 'utils/context/StatementsContext'
import '../../components/styles/ReportPage.scss'

const ProductBalancingStatements = () => {
    const { type } = useParams()
    const { isLoading, setIsLoading } = useContext(LoaderContext)
    const [activeTab, setActiveTab] = useState("all")
    const [activeTabId, setActiveTabId] = useState(0)
     
    const {
        setLastActivePage,
        receiverStatements,
        senderStatements,
        roles,
        getUserPermissionsSummary
    } = useContext(StatementContext)

    useEffect(() => {
        if (!roles.length) {
            getUserPermissionsSummary()
        }
    }, [roles])

    useEffect(() => {
        const ids = {
            'all': 0
        }
        setActiveTabId(ids[activeTab])
    }, [activeTab])


    const handleBreadcrumbClick = () => {
        if (type === "sender") {
            setLastActivePage('Sender')

            if (senderStatements === null) {
                setIsLoading(true)
            }
            else {
                setIsLoading(false)
            }
        }else
        {
            if (receiverStatements === null) {
                setIsLoading(true)
            }
            else {
                setIsLoading(false)
            }
        }
    }

    const handleTabClick = (tab) => {
        setActiveTab(tab)
    }

    const breadcrumbText = type === "receiver" ? 'Receiver Dashboard' : 'Sender Dashboard'

    const content = () => {
        return (
            <>
                <ReportBreadcrumb text={breadcrumbText} handleBreadcrumbClick={handleBreadcrumbClick} />

                {!isLoading ? (
                    <>
                        <ReportHeader isProductBalancing={true} />
                        <TabsContext
                            className="monday-storybook-tabs_bg-color tabs-dashboard pt-2"
                            activeTabId={activeTabId}
                        >
                            <div className="d-flex justify-content-between">
                                <TabList activeTabId={activeTabId}>
                                    <Tab active={activeTab === "all"} onClick={() => handleTabClick("all")} >
                                        All Statements
                                    </Tab>                                   
                                </TabList>
                            </div>
                                <TabPanels activeTabId={activeTabId}>
                                    <TabPanel id="0">
                                        <ProductBalancing type={type}/>
                                    </TabPanel>
                                </TabPanels>
                        </TabsContext>                
                    </>
                ) : <LoadingSpinner />
                }
            </>
        )
    }

    return (
        <Container className="reports-container">
            <Row>
                {content()}
            </Row>
        </Container>
    )
}

export default ProductBalancingStatements